import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from '../../types/entity';

export interface IUserProfile extends IEntity {
  attributes: {
    id: EntityStringId;
    displayName: string | null;
  };
}

export type UserProfile = Entity<IUserProfile>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserProfile: IEntityType<IUserProfile> = vmClient.defineClass({
  typeName: 'UserProfile',
  version: 1,
  persisted: true,
  attributes: {
    displayName: 'string',
  },
});
